import {HISTORY_KEY_SEARCH_TOTAL, HISTORY_LIST_MAX, LOCALSTORAGE_PREFIX_HISTORY} from '../defines/client.const';
import {IsEmptyString} from '../defines/common.func';

export class SearchHistory {
  private name: string | null;
  private listHistory: Array<string>;

  /**
   * 전체 검색 히스토리
   * 현재의 검색 이력이 전체 검색이 아니면, 전체 검색 히스토리를 불러오고 addItem()을 호출할 때 전체 검색 히스토리에도 추가한다.
   */
  private totalSearch?: SearchHistory;


  constructor(obj?: any) {
    this.name         = (obj && obj.name)         ?? null;
    this.listHistory  = new Array<string>();

    this.load();

    /**
     * 전체 검색이 아니라면 전체 검색 히스토리를 불러온다.
     */
    if (this.name !== HISTORY_KEY_SEARCH_TOTAL) {
      this.totalSearch = new SearchHistory({
        name: HISTORY_KEY_SEARCH_TOTAL,
      });
    }
  }

  public get list(): Array<string> {
    return this.listHistory ?? null;
  }
  public get size(): number {
    return this.listHistory.length;
  }
  private setList(value: Array<string>): void {
    this.listHistory = value;
  }
  private get keyHistory(): string | null {
    return this.name;
  }
  public empty(): boolean {
    return this.listHistory.length === 0;
  }


  /**
   * 히스토리를 초기화한다.
   * 현재 검색 이력이 전체검색 이력이 아니면, 전체 검색 이력에도 추가한다.
   * @param item
   */
  public addItem(item: string): void {
    console.log('HistoryService::addItem()', item);
    if (IsEmptyString(this.keyHistory)) {
      console.error('HistoryService::addItem() : reset does not call yet');
      return;
    }

    // 이미 있다면 지우고 앞쪽으로 다시 넣는다.
    const idx = this.list.findIndex(value => value === item);
    if (idx !== -1) {
      this.list.splice(idx, 1);
    }

    this.list.unshift(item);

    // 최대 갯수를 초과하면 마지막 것을 지운다.
    const length = this.list.length;
    if (length > HISTORY_LIST_MAX) {
      this.list.splice(length - 1, 1);
    }

    this.save();

    // 검색이력인 경우에만 처리
    if (this.name?.startsWith('search-')) {
      /**
       * 전체 검색이 아니라면 전체검색에도 추가한다.
       */
      this.totalSearch?.addItem(item);
    }
  }

  public removeItem(item: string): void {
    console.log('HistoryService::removeItem()', item);
    if (IsEmptyString(this.keyHistory)) {
      console.error('HistoryService::addItem() : reset does not call yet');
      return;
    }

    const idx = this.list.findIndex(value => value === item);
    if (idx !== -1) {
      this.list.splice(idx, 1);
      this.save();
    }
  }

  public removeFromIndex(index: number): void {
    console.log('HistoryService::removeFromIndex()', index);
    if (IsEmptyString(this.keyHistory)) {
      console.error('HistoryService::addItem() : reset does not call yet');
      return;
    }

    if (index < this.list.length) {
      this.list.splice(index, 1);
      this.save();
    }
    else {
      console.warn('HistoryService::removeFromIndex() invalid index', index);
    }
  }


  /******************************************************************************
   * LocalStorage 저장하고 로드하는 루틴
   *****************************************************************************/

  toJSON(): any {
    return {
      history_list:       this.list,
    };
  }

  public load(): void {
    if (IsEmptyString(this.keyHistory)) {
      console.error('HistoryService::load() : reset does not call yet');
      return;
    }

    const txtHistory  = localStorage.getItem(LOCALSTORAGE_PREFIX_HISTORY + this.keyHistory);
    const history     = txtHistory ? JSON.parse(txtHistory) : null;

    this.setList((history && history.history_list) ?? new Array<string>());

    console.log(`HistoryService::load(${this.keyHistory})`, this);
  }

  public save(): void {
    if (IsEmptyString(this.keyHistory)) {
      console.error('HistoryService::save() : reset does not call yet');
      return;
    }

    localStorage.setItem(LOCALSTORAGE_PREFIX_HISTORY + this.keyHistory, JSON.stringify(this));
  }
}
